import * as React from 'react'

import { Widget, mk_widget } from 'widgets-for-react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import Links from '../../../plugins/vidda-innerhtml-links'

export interface WysiwygProps {
  input: string
  options?: React.HTMLAttributes<HTMLDivElement> 
}

export class Wysiwyg extends React.Component<RouteComponentProps & WysiwygProps, {}> {
    
  private content: React.RefObject<HTMLDivElement>
  private links: Links
  
  constructor(props: RouteComponentProps & WysiwygProps) {
    super(props);
    this.content = React.createRef<HTMLDivElement>()
  }

  componentDidMount() {
    if (this.content && this.content.current) {
      this.links = new Links(this.content.current, this.props.history)
    }
  }

  componentWillUnmount() {
    if (this.content && this.content.current && this.links) {
      this.links.removeListeners()
    }
  }

  render() {
    return <div 
      {...this.props.options} 
      ref={this.content} 
      dangerouslySetInnerHTML={{ __html: this.props.input }} 
    />
  }
}

const WysiwygWithRouter = withRouter(Wysiwyg)

export let wysiwyg = (options?: React.HTMLAttributes<HTMLDivElement>) : (input: string) => Widget<{}> => {
  return (input: string) => {
    return mk_widget({
      run: _ => React.createElement<WysiwygProps>(WysiwygWithRouter, { input, options })
    })
  }
}
